<template>
	<div id="main-container">

		<LandingArrowLabel class="overlap"/>
		<LandingContactLabel class="overlap"/>
		<RedTopBar class="overlap"/>
		
		<LandingDropdown class="overlap clickable" ref="navRef" @hideSidenav="hideSidenav()" @showSidenav="openSidenav()"/>
		<LandingSidenavMenu ref="sideRef" @toggleEvent="toggleSidenav();" @scrollFeature="scroll('feature')" @scrollProduct="scroll('product')"/>
		
		<router-view id="router-components"></router-view>

		<LandingPageFooter/>

	</div>
</template>

<script>

import 'primeflex/primeflex.css';
import LandingPageFooter from './shared-views/landing-page-footer/Landing-Page-Footer.vue'
import LandingDropdown from './shared-views/landing-smart-navigation/Landing-Dropdown.vue'
import LandingSidenavMenu from './shared-views/landing-smart-navigation/Sidenav-Menu.vue'
import LandingContactLabel from './shared-views/landing-contact-label/Landing-Contact-Label.vue'
import LandingArrowLabel from './shared-views/landing-arrow-label/Landing-Arrow-Label.vue'
import RedTopBar from './shared-views/red-top-bar/Red-Top-Bar.vue'

import JsonProvider from '../services/DataService.js'


export default {
	name: 'MainPage',

	components: {
		LandingPageFooter,
		LandingContactLabel,
		LandingDropdown,
		LandingSidenavMenu,
		LandingArrowLabel,
		RedTopBar
	},

	watch:{
		$route(to){
			if(to.path == "/" && to.hash) {
				setTimeout(function() {window.location.hash = to.hash}, 1);
			} else if(to.path == "/" && to.params.newLocation != null) {
			var el = document.getElementById(to.params.newLocation);
					setTimeout(function() {
						el = document.getElementById(to.params.newLocation);
						var rect = el.getBoundingClientRect();
						
						window.scrollTo({ top: rect.y, left: 0});
						}, 300);
		}
					else {
					window.scroll(0 ,0);
					}
				var cLabel = document.getElementById("contact-container");
				this.handleScroll();
					if(to.path == "/contact") {
					cLabel.style.display = "none";
					window.removeEventListener('scroll', this.handleScroll);
				} else {
					if(screen.width > 767) {
						cLabel.style.display = "block"; 
						}
					window.addEventListener('scroll', this.handleScroll);
				}
			
			var x = window.matchMedia('(max-width: 767px)');
			if(x.matches) {
				this.hideSidenav();
				document.getElementById("sidenav").removeEventListener("transitionend", this.undisplayNav);
				this.setDropdownIcon(false);
				}
		}
	},


	methods: {
		openSidenav() {
			document.getElementById("sidenav").style.left = "unset";
			document.getElementById("sidenav").style.width = "250px";
						document.getElementById("sidenav").style.zIndex = 11;
			
			document.getElementById("dropdown-container").style.marginRight = "250px";
			
			var el = document.getElementById("router-components");
			el.style.marginRight = "250px";
			el.style.marginLeft = "-250px";	
		},
		
		hideSidenav() {

			this.$refs.sideRef.refreshNav();
			var sidenav = document.getElementById("sidenav");
			var el = document.getElementById("router-components");
			sidenav.addEventListener(("transitionend"), this.undisplayNav);
			sidenav.style.width = "0px";
			sidenav.style.zIndex = -1;
	
			document.getElementById("dropdown-container").style.marginRight = "0px";

			el.style.marginRight = "0";
			el.style.marginLeft = "0";	

			if(document.getElementById("hero-image") != null)
				document.getElementById("hero-image").style.right = "0px";
		},

		toggleSidenav() {
			this.$refs.navRef.toggle();
		},

		setDropdownIcon(toggled) {
			this.$refs.navRef.setIcon(toggled);
		},
		
		scroll(ref) {
			if(this.$route.path=="/") {
				var el = document.getElementById(ref);
				var rect = el.getBoundingClientRect();
				setTimeout(function() {
					window.scrollTo({top: rect.y - 30, left: 0}), 300});
			}
		},
		
		
		undisplayNav() {
			document.getElementById("sidenav").style.left = 0;
			document.getElementById("sidenav").removeEventListener("transitionend", this.undisplayNav);
			
		},

		handleScroll() {
			var el = document.getElementById("header-bar");
			var arrLabel = document.getElementById("arrow-container");

			if(window.pageYOffset > el.offsetHeight && arrLabel.style.display == "none") {
				arrLabel.style.display = "block";
				
				setTimeout(function () {
				arrLabel.style.opacity = 1;
				}, 30);

					} else if (window.pageYOffset < el.offsetHeight && arrLabel.style.display != "none") {
						arrLabel.style.opacity = 0;
						arrLabel.addEventListener(("transitionend"), function() {	
						arrLabel.style.display = "none";
						}, {capture: false,
							once: true,
							passive: false
						});
			}
		}
	},
	
	async created() {
		var dataService = new JsonProvider();
		var infos = await dataService.fetchJsonObject('general-infos');
		//eslint-disable-next-line no-console
		console.log(infos);
		document.title = infos[0].title;
	},
	
	beforeMount() {
		window.addEventListener('scroll', this.handleScroll);
	},
	
	beforeDestroy () {
		window.removeEventListener('scroll', this.handleScroll);
	}
	
}

</script>

<style scoped>

	#main-container {
		background-color: #e5e5e5;
}

	#router-components {
		overflow-x: hidden;
		transition: 0.5s;
	}

	@media (max-width: 767px) {
		.inner-main {
			margin-left: 0px;
			margin-right: 0px;
		}
	}
	
	@media (min-width: 768px) {
		LandingDropdown, LandingSidenavMenu {
			display: none;
		}
	}

</style>
